import React from 'react';
import PropTypes from 'prop-types';
import observeRootStore from '../../../components/hoc/observeRootStore';

import './slide.scss';

const Slide = props => {
    const { rootStore, children, sid, bg, ...other } = props;
    const bgImg = { backgroundImage: bg && `url(${bg})` };
    const isSelected = rootStore.uiStore.selectedState && rootStore.uiStore.selectedState.gid === sid;

    return (
        <div id={`slide__${sid}`} className={'slide ' + (isSelected ? 'is-selected' : '')} {...other} style={bgImg}>
            <div className='align-middle'>
                {children}
            </div>
        </div>
    )
};

Slide.propTypes = {
    rootStore: PropTypes.shape({
        uiStore: PropTypes.shape({
            selectedState: PropTypes.shape({
                gid: PropTypes.string,
            }),
        }).isRequired,
    }).isRequired,
    children: PropTypes.node,
    sid: PropTypes.string.isRequired,
    bg: PropTypes.string,
};

export default observeRootStore(Slide);
